//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { videoPlayer } from 'vue-video-player'
import 'jquery'
import 'jquery.scrollto'
import 'jquery-browserify'
import 'jquery-mousewheel'
export default {
  mounted: function () {
    window.scrollTo(0, 0)
    var _this = this
    var body = $('body')
    console.log('body set overflow')
    body.addClass('scrollhidden')
    console.log(body)
    $('.mainAll').mousewheel(function (event, num) {
      event = event || window.event
      // if(num < 0 && _this.config.curIdx != _this.config.screenLen - 1){
      event.preventDefault()
      // }
      console.log('sssssssssss')
      if (_this.config.pageSlide) return
      var idx
      if (num < 0 && _this.config.curIdx < _this.config.screenLen - 1) {
        _this.config.pageSlide = true
        _this.config.curIdx++
        idx = _this.config.curIdx
        _this.goPage(idx)
      }
      if (num > 0 && _this.config.curIdx > 0) {
        _this.config.pageSlide = true
        _this.config.curIdx--
        idx = _this.config.curIdx
        _this.goPage(idx)
      }
    })
    _this.setBgsize()
    $(window).resize(function () {
      _this.setBgsize()
      $.scrollTo('.screen-' + _this.config.curIdx, 0)
    })
  },
  data () {
    return {
      selectCityItem: '首页',
      config: {
        screenLen: 7,
        curIdx: 0,
        pageSlide: false
      },
      playerOptions: {
        height: '681',
        playbackRates: [0.7, 1, 1.3, 1.5, 1.7],
        sources: [{
          type: 'video/mp4',
          src: 'http://114.215.45.205:8088/Movie_00_V.mp4'
        }]
        // poster: 'http://www.icloudpay.me/static/pic/video(1).jpg'
      }
    }
  },
  components: {
    videoPlayer
  },
  methods: {
    nextPage: function () {
      if (this.config.curIdx < this.config.screenLen - 1) {
        this.config.curIdx++
        this.goPage(this.config.curIdx)
      }
    },
    goPage: function (num) {
      var _this = this
      console.log(num)
      $.scrollTo('.screen-' + num, 700, function () {
        // slide_page_item.removeClass("trig-current").eq(num).addClass("trig-current");
        _this.config.pageSlide = false
        // screenStatus();
      })
      var element = document.getElementById('move1')
      console.log(element)
      if (num === 2) {
        element.classList.add('fide-animation')
      } else {
        element.classList.remove('fide-animation')
      }
      var element2 = document.getElementById('move2')
      if (num === 3) {
        element2.classList.add('fide-animation')
      } else {
        element2.classList.remove('fide-animation')
      }
    },
    selectCity: function (item) {
      this.selectCityItem = item
      if (item === '首页') {
        // this.$router.push({path:'/'})
      } else if (item === '产品介绍') {
        this.$router.push({path: 'productinfo'})
        this.$destroy()
      } else if (item === '联系我们') {
        this.$router.push({path: 'contact'})
        this.$destroy()
      } else if (item === '新闻动态') {
        this.$router.push({path: 'newDy'})
        this.$destroy()
      }
    },
    setBgsize: function () {
      var winHeight
      var screenItem = $('.screenItem')
      winHeight = $(window).height() >= 860 ? $(window).height() : 860
      screenItem.css({
        'height': winHeight
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/views/Guanwang/MainPage.vue